import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const MODULE_CODE_ROUTE_DATA_KEY = 'moduleCode';

@Injectable({ providedIn: 'root' })
export class ModuleAccessGuard {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  private fn = async (route: ActivatedRouteSnapshot): Promise<boolean> => {
    while (!this.authService.isInitialized()) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    await this.authService.refreshMe();

    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/no-access']);

      return false;
    }

    const moduleCode = this.getModuleCode(route);
    if (!moduleCode) {
      this.router.navigate(['/no-access']);

      return false;
    }

    if (this.authService.isModuleUnderMaintenance(moduleCode)) {
      this.router.navigate(['/under-construction']);

      return false;
    }

    if (!this.authService.hasAcceptedTc()) {
      this.router.navigate(['/']);

      return false;
    }

    if (!this.authService.canUserAccessModules(moduleCode)) {
      this.router.navigate(['/no-access']);

      return false;
    }

    return true;
  };

  canActivate: CanActivateFn = (route) => this.fn(route);
  canActivateChild: CanActivateFn = (route) => this.fn(route);

  private getModuleCode(route: ActivatedRouteSnapshot): string | undefined {
    return [...route.pathFromRoot]
      .reverse()
      .map((snapshot) => snapshot.data[MODULE_CODE_ROUTE_DATA_KEY])
      .find((moduleCode): moduleCode is string => typeof moduleCode === 'string' && moduleCode.length > 0);
  }
}
